import type {
  BulkUpdateControlResultOwnerRequestDto,
  BulkUpdateControlResultWorkflowStepRequestDto,
} from "@/spz-api/model";

export class ControlResultMapper {
  static toBulkUpdateOwnerRequestWithFilters(
    ownerId: string,
    filters?: string,
  ): BulkUpdateControlResultOwnerRequestDto {
    return {
      ownerId,
      filters: filters && JSON.parse(filters).filters ? filters : "filters=[]",
    };
  }

  static toBulkUpdateOwnerRequestWithResults(
    ownerId: string,
    resultIds: string[],
  ): BulkUpdateControlResultOwnerRequestDto {
    return {
      ownerId,
      resultIds,
    };
  }

  static toBulkUpdateWorkflowStepRequestWithResults(
    transitionId: string,
    formData: Record<string, unknown> | null,
    resultIds: string[],
  ): BulkUpdateControlResultWorkflowStepRequestDto {
    return {
      transitionId,
      data: formData,
      resultIds,
    };
  }

  static toBulkUpdateWorkflowStepRequestWithFilters(
    transitionId: string,
    formData: Record<string, unknown> | null,
    filters?: string,
  ): BulkUpdateControlResultWorkflowStepRequestDto {
    return {
      transitionId,
      data: formData,
      filters: filters && JSON.parse(filters).filters ? filters : "filters=[]",
    };
  }
}
